import React, { useEffect } from "react";
import useState from 'react-usestateref';
import Navbar from "../components/Navbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Typography,
  Alert,
  IconButton,
} from "@mui/material";
import {
  getUserSession,
  getAuthHeader
} from '../authorization/FetchToken';
import Swal from 'sweetalert2';
import InfoTip from "../components/InfoTip";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import Drawer from "@mui/material/Drawer";

const API_BASE = process.env.REACT_APP_USER_MANAGEMENT_SERVICE

const UserManagement = () => {

const [userSession, setUserSession,userSessionRef] = useState({
    token: "",
    userId: "",
    orgId: "",
    userName: "",
    orgName: "",
    role: "",
    loginTime: "",
    expiresAt: "",
    paymentStatus: "",
    active: false
  });

  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
    services: [],
  });
  
  const [editedUser, setEditingUser] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [orgId,setOrgId,orgIdRef] = useState("");
  const [orgName,setOrgName,orgNameRef] = useState("");
  const [createdBy,setCreatedBy,createdByRef] = useState("");
  const [success, setSuccess] = useState("");
  const [loggedInUserRole,setloggedInUserRole] = useState("")
  const [errorMessage, setErrorMessage] = useState("");
  const [openDoc, setOpenDoc] = useState(false);
  const [doc, setDoc] = useState("");

  // Generic API caller
  const callApi = async (endpoint, body) => {
    const resp = await fetch(`${API_BASE}${endpoint}`, {
      method: "POST",
      headers: {
        'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
        ...await getAuthHeader(),
    },
      body: JSON.stringify(body),
    });
    if (!resp.ok) throw new Error(await resp.text());
    return resp.json();
  };


useEffect(() => {
  const initSession = async () => {
      const sessionToken = localStorage.getItem('token');
      if (!sessionToken) return;

      const session = await getUserSession(sessionToken);
      const sessionData = session["userSessionData"];

      // Set ref first — synchronous, immediately available
      userSessionRef.current = sessionData;
      orgIdRef.current = sessionData["orgId"];

      // Set state after — just for UI rendering
      setUserSession(sessionData);
      setOrgId(sessionData["orgId"]);
      setOrgName(sessionData["orgName"]);
      setloggedInUserRole(sessionData["role"]);
      setCreatedBy(sessionData["userName"].trim().replace(/^"+|"+$/g, ''));

      // Call directly here with the data you have right now
      // No need to wait for state updates
      await fetchUsers(sessionData["orgId"]);
  };

  initSession();
}, []);


  const fetchUsers = async (id) => {
  const resolvedOrgId = id ?? orgIdRef.current;
  console.log("orgId::1", resolvedOrgId);
  try {
      const data = await callApi("/allUsers", { orgId: resolvedOrgId });
      setUsers(data);
  } catch (err) {
      setError("Failed to load users: " + err.message);
  }
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const generatePassword = () => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let pwd = "";
    for (let i = 0; i < 12; i++) {
      pwd += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setForm({ ...form, password: pwd });
  };

  // Create or update user
  const handleSubmit = async (e) => {
    e.preventDefault();
    let userAction = ""
    try {
      if (form.email.includes("`")) {
        setError("Character ` (backtick) is not allawed in email id's");
        return;
      }
      setLoading(true);
      console.log("form::1",editedUser)
      if (editedUser) {
        const payload = {
            orgId,
            orgName,
            userDataDocId:editedUser.userData.DOC_ID,
            userRelDataDocId:editedUser.userRelData.DOC_ID,
            createdBy,
            ...form,
          };

        await callApi("/updateUser", payload)
      } else {
        const payload = {
            orgId,
            orgName,
            createdBy,
            ...form,
          };
        await callApi("/createUser", payload);
        await callApi("/sendEmailLink", {
          email:orgName + "`" + form.email,
          emailType:"user_email",
          creatorEmail: createdBy,
          orgName:orgName,
          userPassword:form.password
      });
      }

      /*
      await callApi("/sendEmailLink", {
        email:orgName + "`" + form.email,
        emailType:"user_email",
        creatorEmail: "",
        orgName:orgName,
		    userPassword:form.password
    });
    */

      setForm({ name: "", email: "", role: "", services: [] });
      setEditingUser(null);
      fetchUsers();
    } catch (err) {
      setError("Create User failed: " + JSON.parse(err.message).message);
    } finally {
      setSuccess("User: " + form.email + " created successfully");
      setLoading(false);
    }
  };

  // Delete user
  const handleDelete = async (u) => {
    try {
      console.log("form::2",u)
      const payload = {
        userDocId:u.userData.DOC_ID,
        userOrgRelDocId:u.userRelData.DOC_ID,
        orgName: orgName,
        userOrgRelUUID: u.userRelData.UUID,
        deletedBy: createdBy,

      };
      await callApi("/deleteUser", 
        payload

      );
      fetchUsers();
    } catch (err) {
      setError("Delete failed: " + err.message);
    } finally {
      setSuccess("User: " + u.userData.EMAIL + " deleted successfully");
      setLoading(false);

    }
  };

  // Start editing
  const handleEdit = (u) => {
    /*
    if (u.userData.EMAIL.includes("`")) {
      setError("Character ` (backtick) is not allawed in email id's");
      return;
    }
    */
    setEditingUser(u);
    setForm({
      name: u.userData.NAME,
      email: u.userData.EMAIL.split("`")[1],
      role: u.userRelData.ROLE,
      services: u.userRelData.services || [],
    });
  };
  
  return (
  <div className="main-container" style={{ marginLeft: "24px" }}>
  <div
  style={{
    fontFamily: "Inter, sans-serif",
    backgroundColor: "#f9fafb",
    minHeight: "100vh",
    color: "#111827",
  }}
 >
    <div style={{ padding: '1rem' }}>
    <div style={{ display: "flex", alignItems: "center", gap: "8px",marginBottom: '1rem',}}>
    <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#0a2540",
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
            letterSpacing: "0.3px",
          }}
        >
         User Management
        </Typography>
        <InfoTip
        keyword="user_management"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>

        {error && (
  <Alert
    severity="error"
    action={
      <IconButton
        size="small"
        onClick={() => setError("")}
        color="inherit"
      >
        ✕
      </IconButton>
    }
    sx={{ mb: 2 }}
  >
    {error}
  </Alert>
)}

{success && (
  <Alert
    severity="success"
    action={
      <IconButton
        size="small"
        onClick={() => setSuccess("")}
        color="inherit"
      >
        ✕
      </IconButton>
    }
    sx={{ mb: 2 }}
  >
    {success}
  </Alert>
)}


    {/* User Form */}
    <div
    style={{
      maxWidth: "700px",
      background: "#ffffff",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
      border: "1px solid #e5e7eb",
    }}
  >
  {/* form here */}
  <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        marginBottom: "30px",
      }}
    >
      <div style={{ display: "flex", gap: "12px" }}>
        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          required
          style={{
            flex: 1,
            padding: "8px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
        <input
          name="email"
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={handleChange}
          required
          disabled={!!editedUser}
          style={{
            flex: 1,
            padding: "8px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
            backgroundColor: editedUser ? "#f3f4f6" : "white",
          }}
        />
      </div>

      {/* Password Field */}
      <div style={{ position: "relative" }}>
        <input
          name="password"
          placeholder="Password"
          required={!editedUser}
          disabled={!!editedUser}
          type={showPassword ? "text" : "password"}
          value={form.password}
          onChange={handleChange}
          style={{
            width: "100%",
            padding: "8px 40px 8px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
            boxSizing: "border-box",
          }}
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#555",
          }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>

      <button
        type="button"
        onClick={generatePassword}
        disabled={!!editedUser}
        style={{
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          padding: "8px 14px",
          fontSize: "14px",
          backgroundColor:
            !!editedUser
              ? "#ccc"
              : "#2563eb",
            cursor:
             !!editedUser
              ? "not-allowed"
              : "pointer",
          alignSelf: "flex-start",
        }}
      >
        Auto Generate Password
      </button>

      <div style={{ display: "flex", gap: "12px" }}>
      <select
        name="role"
        value={form.role}
        onChange={handleChange}
        required
        style={{
          width: "520px",
          flex: 1,
          padding: "8px 10px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontSize: "14px",
          backgroundColor: "#fff",
          cursor: "pointer",
        }}
      >
          <option value="">Select Role</option>
          <option value="admin">Admin</option>
          <option value="developer">Developer</option>
          <option value="functions_subscriber">Functions Subscriber</option>
          <option value="viewer">Viewer</option>
        </select>
      </div>

      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <button
          type="submit"
          disabled={
            loading || !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
          }
          style={{
            backgroundColor:
            loading  ||
            !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
              ? "#ccc"
              : "#1f8a70",
            cursor:
            loading  ||
            !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
              ? "not-allowed"
              : "pointer",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            fontSize: "14px",
          }}
        >
          {loading
            ? editedUser
              ? "Updating..."
              : "Creating..."
            : editedUser
            ? "Update User"
            : "Create User"}
        </button>

        {editedUser ? (
          <button
            type="button"
            onClick={() => {
              setForm({ name: "", password: "", email: "", role: "", services: [] });
              setEditingUser(null);
            }}
            style={{
              background: "linear-gradient(135deg, #ff7f50, #ff6600)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: "14px",
            }}  
          >
            Cancel
          </button>
        ) : (
          <button
            type="button"
            onClick={() => {
              setForm({ name: "", password: "", email: "", role: "", services: [] });
            }}
            style={{
              background: "linear-gradient(135deg, #ff7f50, #ff6600)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Clear
          </button>
        )}
      </div>
    </form>
    </div>

    {/* User Table */}
    <h3 style={{ marginBottom: "10px" }}>All Users</h3>
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "14px",
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#f3f4f6" }}>
          <th style={{ textAlign: "left", padding: "10px" }}>Name</th>
          <th style={{ textAlign: "left", padding: "10px" }}>Email</th>
          <th style={{ textAlign: "left", padding: "10px" }}>Role</th>
          <th style={{ textAlign: "left", padding: "10px" }}>Services</th>
          <th style={{ textAlign: "left", padding: "10px" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {users.map((u) => (
          <tr
            key={u.userData.EMAIL.split("`")[1]}
            style={{
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <td style={{ padding: "10px" }}>{u.userData.NAME}</td>
            <td style={{ padding: "10px" }}>{u.userData.EMAIL.split("`")[1]}</td>
            <td style={{ padding: "10px" }}>{u.userRelData.ROLE}</td>
            <td style={{ padding: "10px" }}>
              {(u.userRelData.services || []).join(", ")}
            </td>
            <td style={{ padding: "10px" }}>
              <button
                onClick={() => handleEdit(u)}
                disabled={
                  u.userRelData.ROLE === "ROOT" ||
                  !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                }
                style={{
                  backgroundColor:
                    u.userRelData.ROLE === "ROOT" ||
                    !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                      ? "#ccc"
                      : "#3b82f6",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 10px",
                  cursor:
                    u.userRelData.ROLE === "ROOT" ||
                    !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                      ? "not-allowed"
                      : "pointer",
                  marginRight: "8px",
                }}
              >
                Edit
              </button>

              <button
                onClick={() => {

                  Swal.fire({
                    title: 'Confirm Delete',
                    text:  `Are you sure you want to delete ${u.userData.EMAIL.split("`")[1]}?`,
                    icon: 'warning',
                    background: '#ccc',
                    color: '#000',
                    iconColor: '#d32f2f',
                    confirmButtonText: 'Delete',
                    confirmButtonColor: '#d32f2f',
                    cancelButtonText: 'Cancel',
                    cancelButtonColor: '#f5c518',
                    showCancelButton: true,
                  }).then((result) => {
                  if (result.isConfirmed)
                      handleDelete(u);
                  });

                }}
                disabled={
                  u.userRelData.ROLE === "ROOT" ||
                  !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                }
                style={{
                  backgroundColor:
                    u.userRelData.ROLE === "ROOT" ||
                    !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                      ? "#ccc"
                      : "#ef4444",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 10px",
                  cursor:
                    u.userRelData.ROLE === "ROOT" ||
                    !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
        {users.length === 0 && (
          <tr>
            <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
              No users found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

<Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
  >

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
    >
  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>
    </div>

  </div>

</Drawer>


</div>
  );
};

export default UserManagement;

//{error && <p style={{ color: "red", marginBottom: "10px" }}>{error}</p>}
